import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PageLoader } from './LoadingStates';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <PageLoader message="Authenticating..." />;
  }

  if (!user) {
    // Redirect to login page with return url
    return <Navigate to="/login?system=vms" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
